import React from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

const educationData = [
  {
    id: 1,
    institution: "Garden City University",
    qualification: "Bachelor of Computer Application, Computer Science",
    subjects:
      "C-Programming, Computer Networks, Data Structures, DBMS, Java, Python",
    src: "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1752210378/garden_city_college_of_sc_and_mgt_studies_logo_zy7kty.jpg",
    year: "2025-2028",
  },
  {
    id: 2,
    institution: "National Institute of Open Schooling (NIOS)",
    qualification: "Senior Secondary Education",
    subjects: "English, Computer Science, Business Studies, Home Science, DEO ",
    src: "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1739635906/Projects/NIOS-Logo_fo53zz.png",
  },
];

const certificationsData = [
  {
    id: 1,
    title: "Front End Development",
    provider: "Info Campus Software Training Institute",
    year: "2021",
  },
  {
    id: 2,
    title: "Backend End Development",
    provider: "Info Campus Software Training Institute",
    year: "2021",
  },
  {
    id: 3,
    title: "UI/UX Design",
    provider: "Internshala Training",
    year: "2022",
  },
  {
    id: 4,
    title: "Java Mastering the Fundamentals",
    provider: "Scaler Topics",
    year: "2025",
  },
  {
    id: 5,
    title: "Introduction to computers",
    provider: "Microsoft",
    year: "2025",
  },
];

const workExperienceData = [
  {
    id: 1,
    position: "Senior SEO Developer & Senior Full Stack Developer",
    company: "SparklerPro",
    year: "Feb 2021 - June 2024",
    description:
      "Leading SEO strategies, full-stack development, and optimizing web applications for enhanced performance and user experience.",
  },
  {
    id: 2,
    position: "Digital Marketer & Junior Front-End Developer",
    company: "Eduprov Education",
    year: "June 2019 - Aug 2022",
    description:
      "Managed digital marketing campaigns and contributed to front-end development projects for enhanced UI/UX experience.",
  },
];

const Education = () => {
  const theme = useSelector((state) => state.theme.theme);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col items-center py-20 px-6 lg:px-0"
    >
      {/* Education Section */}
      <div className="w-full max-w-4xl">
        <h2 className="text-[38px] lg:text-[48px] font-extrabold text-center mb-8 bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text animate-gradient">
          Education
        </h2>
        {educationData.map((edu, index) => (
          <motion.div
            key={edu.id}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
            className="flex items-center bg-gradient-to-br from-gray-100 to-white dark:from-gray-800 dark:to-gray-900 shadow-xl rounded-lg p-6 mb-6 border-l-4 border-blue-500 hover:border-blue-700 transition-all"
          >
            <img
              src={edu.src}
              alt="NIOS Logo"
              className="w-16 h-16 object-contain mr-6 "
            />
            <div>
              <h3 className="text-xl font-semibold">{edu.qualification}</h3>
              <p className="text-gray-600 dark:text-gray-300">
                {edu.institution}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Subjects: {edu.subjects}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                {edu.year ? edu?.year : null}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Certifications Section */}
      <div className="w-full max-w-4xl mt-16">
        <h2 className="text-[38px] lg:text-[48px] font-extrabold text-center mb-8 bg-gradient-to-r from-green-500 to-teal-500 text-transparent bg-clip-text animate-gradient">
          Certifications
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {certificationsData.map((cert, index) => (
            <motion.div
              key={cert.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
              className="bg-gradient-to-br from-gray-100 to-white dark:from-gray-800 dark:to-gray-900 shadow-xl rounded-lg p-6 border-l-4 border-green-500 hover:border-green-700 transition-all"
            >
              <h3 className="text-xl font-semibold">{cert.title}</h3>
              <p className="text-gray-600 dark:text-gray-300">
                {cert.provider}
              </p>
              <p className="text-sm text-green-500 font-medium">{cert.year}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Work Experience Section */}
      {/* <div className="w-full max-w-4xl mt-16">
        <h2 className="text-[38px] lg:text-[48px] font-extrabold text-center mb-8 bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text animate-gradient">
          Work Experience
        </h2>
        {workExperienceData.map((work, index) => (
          <motion.div
            key={work.id}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
            className="bg-gradient-to-br from-gray-100 to-white dark:from-gray-800 dark:to-gray-900 shadow-xl rounded-lg p-6 mb-6 border-l-4 border-red-500 hover:border-red-700 transition-all"
          >
            <h3 className="text-xl font-semibold">{work.position}</h3>
            <p className="text-gray-600 dark:text-gray-300">{work.company}</p>
            <p className="text-sm text-red-500 font-medium">{work.year}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
              {work.description}
            </p>
          </motion.div>
        ))}
      </div> */}
    </motion.div>
  );
};

export default Education;
